<template>
  <Modal v-model="switchShippingWarehouseModal" :title="$t('key1006906')" :mask-closable="false">
    <div class="flex align-items-center mb20">
      <span>{{ $t('key1006907') }}</span>
      <Select v-model="warehouseId" filterable class="width_300">
        <Option v-for="item in shippingWarehouseData" :disabled="item.availableNumber<=0"
          :value="item.warehouseId" :key="item.warehouseId" :label="item.warehouseName">
          <div class="flex align-items-center justify-content-between">
            <span :class="item.availableNumber<=0 ? '' : 'color-333'">{{ item.warehouseName }}</span>
            <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + (item.availableNumber || 0) + '）' }}</span>
          </div>
        </Option>
      </Select>
    </div>
    <template #footer>
      <Button @click="switchShippingWarehouseModal=false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="!warehouseId" @click="switchShippingWarehouseBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'switchShippingWarehouseModal',
  mixins: [Mixin],
  data() {
    return {
      switchShippingWarehouseModal: false,
      warehouseId: null,
      shippingWarehouseData: [],
      switchShippingWarehouseDetails: {},
    };
  },
  methods: {
    // 初始化数据
    initSwitchShippingWarehouseData(obj) {
      this.warehouseId = null;
      this.switchShippingWarehouseDetails = obj;
      let packageInfoOrderGoodsBosList = obj.packageInfoOrderGoodsBos || [];
      this.shippingWarehouseData = [];
      let query = {
        packageGoodsList: packageInfoOrderGoodsBosList.map((item) => {
          return {
            packageId: item.packageId,
            quantity: item.quantity,
            productGoodsId: item.productGoodsId,
          };
        }),
        ymsWarehouseId: obj.ymsWarehouseId,
      };
      this.axios.post(api.post_wmsWarehouse_getYmsWarehouseCollectionSetting, query, {loading: true}).then((response) => {
        if (response.data.code === 0) {
          this.shippingWarehouseData = response.data.datas || [];
          if (this.shippingWarehouseData.length > 0) {
            this.shippingWarehouseData.map((item) => {
              if (item.warehouseId === obj.warehouseId) {
                this.warehouseId = item.warehouseId;
              }
            });
          }
          this.switchShippingWarehouseModal = true;
        }
      });
    },
    // 确定
    switchShippingWarehouseBtn() {
      let query = {
        packageId: this.switchShippingWarehouseDetails.packageId,
        warehouseId: this.warehouseId
      };
      this.axios.post(api.post_packageInfo_updatePackageDeliveryWarehouse, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
        if (res.data.code === 0) {
          this.switchShippingWarehouseModal = false;
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          this.$emit('updateData', true);
        }
      });
    }
  }
};
</script>

<style lang="less">

</style>
